import React from 'react'
import { NavItem, utils, SafeAnchor } from 'react-bootstrap'
import classNames from 'classnames'

// Override NavItem render method to allow dynamic componentClass
NavItem.prototype.render = function() {
  const {
    active,
    disabled,
    onClick,
    className,
    componentClass = SafeAnchor,
    style,
    ...props
  } = this.props

  const Component = componentClass

  delete props.onSelect
  delete props.eventKey

  // These are injected down by `<Nav>` for building `<SubNav>`s.
  delete props.activeKey
  delete props.activeHref

  if (!props.role) {
    if (props.href === '#') {
      props.role = 'button'
    }
  } else if (props.role === 'tab') {
    props['aria-selected'] = active
  }

  return (
    <li
      tabIndex="1"
      role="presentation"
      className={classNames(className, { active, disabled })}
      style={style}
    >
      <Component
        {...props}
        disabled={disabled}
        onClick={utils.createChainedFunction(onClick, this.handleClick)}
      />
    </li>
  )
}

export default NavItem



// WEBPACK FOOTER //
// ./src/components/ReactBootstrapOverrides/NavItem.js